<template>
  <div>
    <div v-if="loader">
      <div class="spinner"></div>
    </div>
    <!--  Banner Starts Here   -->
    <section class="inner_banner">
      <div class="container_large">
        <div class="inner_banner_content">
          <h1>Frequently Asked <span>Questions</span></h1>
        </div>
      </div>
    </section>
    <!--  Banner Ends Here   -->

    <!--   Main Content Start Here   -->
    <main>
      <section class="default_wraper">
        <div class="container_large">
          <div class="row">
            <div class="col-md-12 col-lg-6">
              <div class="faq_img">
                <img
                  src="/src/assets/images/faq-img.png"
                  class="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div class="col-md-12 col-lg-6">
              <div class="faqs_holder">
                <div class="faq_content">
                  <div
                    class="accordion"
                    id="accordionExample"
                    v-if="faqs && faqs.length"
                  >
                    <div
                      class="accordion-item"
                      v-for="(data, index) in faqs"
                      :key="data.id"
                    >
                      <h2 class="accordion-header" :id="'heading' + index">
                        <button
                          class="accordion-button"
                          :class="{ collapsed: index != 0 }"
                          type="button"
                          data-bs-toggle="collapse"
                          :data-bs-target="'#collapse' + index"
                          :aria-expanded="index == 0 ? true : false"
                          :aria-controls="'collapse' + index"
                        >
                          {{ data.question ? data.question : "" }}
                        </button>
                      </h2>
                      <div
                        :id="'collapse' + index"
                        class="accordion-collapse collapse"
                        :class="{ show: index == 0 }"
                        :aria-labelledby="'heading' + index"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          {{ data.answer ? data.answer : "" }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    <!--   Main Content End Here   -->
  </div>
</template>
<script>
import faqsApis from "../Apis/faqs";

export default {
  data() {
    return {
      faqs: null,
      loader: true,
    };
  },

  async created() {
    this.faqs = (await faqsApis.requestFaqs("get", "")).data;
    setTimeout(() => {
      this.loader = false;
    }, 1000);
  },
};
</script>


// WEBPACK FOOTER //
// src/components/faqs.vue